import { createApp } from 'vue'
import Startup from './Startup.vue'

const app = createApp(Startup)

export default app
